<template>
    <emc-card-stats
        color="blue darken-2"
        icon="mdi-flask-outline"
        icon-large
        :title="title"
        :value="ambiences"
        sub-text="Número de ambientes"
        >
        <template v-slot:tools>
            <emc-chart-refresh-status :label="statusLabel" :failed="hasFailed" :error-code="errorCode" />
        </template>
        <template v-slot:actions>
            <emc-button-icon btn-small :disabled="isBusy" icon="mdi-refresh-circle" :text="updated_at || `Atualizar`" color="success" @click.prevent.stop="start()" />
        </template>
        </emc-card-stats>
</template>

<script>

import { getCurrentInstance } from 'vue'
import { mapActions } from 'vuex'
import { useChartRefresh } from '@/composables/useChartRefresh'

export default {
    name: 'EmcChartAmbienceNumber',
    setup() {
        const { proxy } = getCurrentInstance()

        return useChartRefresh({
            refreshAction: 'chart/ActionAmbienceNumbersRefresh',
            onFinished: () => proxy.getData()
        })
    },
    data () {
        return {
            ambiences: '0',
            title: '',
            updated_at: null
        }
    },
    methods: {
        ...mapActions('chart', ['ActionChartAmbienceNumber']),
        async getData() {
            await this.ActionChartAmbienceNumber()
                .then((r) => {

                    let ambiences = r.data?.value || 0;
                    this.ambiences = ambiences.toString()
                    this.title = r.data.title
                    this.updated_at = r.data.updated_at

                    // Recarga já em andamento (normalmente a carga noturna):
                    // o card mostra o andamento sem o usuário ter clicado.
                    this.adopt(r.data.refresh)
                })
        }
    },
    created(){
        this.getData()
    }

    
}
</script>